import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AdminContext } from "../../context/adminContext";
import Loader from "../../UI/Loader/Loader";
import CoveredBackground from "../../UI/СoveredBackground/СoveredBackground";
import ErrorMessage from "../../UI/ErrorMessage/ErrorMessage";
import LittleNotify from "../../UI/Notification/LittleNotify/LittleNotify";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const MasUserPage = () => {
  const params = useParams();
  const { getMasByUserId, disableMas, enableMas, masDeletePhPost } =
    useContext(AdminContext);
  const [mas, setMas] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const disableHandler = (el) => {
    el.preventDefault();

    disableMas(mas.mas.id).then((res) => {
      setMas(null);
      if (res.status) {
        getMasByUserId(params.user_id).then((res) => {
          if (res.status === 200) return setMas(res.data);
          else return setError(res.response.data.message);
        });
      }
    });
  };

  const closeSuccess = () => {
    setSuccess(null);
  };

  const enableHandler = (el) => {
    el.preventDefault();

    enableMas(mas.mas.id).then((res) => {
      setMas(null);
      if (res.status) {
        getMasByUserId(params.user_id).then((res) => {
          if (res.status === 200) return setMas(res.data);
          else return setError(res.response.data.message);
        });
      }
    });
  };

  const deleteHandler = (masId, phId) => {
    masDeletePhPost(masId, phId).then((res) => {
      if (res.status === 200) {
        setMas(null);
        setSuccess(res.data);
        getMasByUserId(params.user_id).then((res) => {
          if (res.status === 200) return setMas(res.data);
          else return setError(res.response.data.message);
        });
      } else {
        setError(res.response.data.message);
      }
    });
  };

  useEffect(() => {
    getMasByUserId(params.user_id).then((res) => {
      if (res.status === 200) {
        document.title =
          "МАС " + res.data.mas.surname + " " + res.data.mas.name;
        return setMas(res.data);
      } else return setError(res.response.data.message);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container">
      {!mas && !error ? (
        <div style={{ position: "relative", minHeight: 320 }}>
          <CoveredBackground>
            <Loader />
          </CoveredBackground>
        </div>
      ) : error ? (
        <div style={{ marginTop: 50 }}>
          <ErrorMessage message={error} />
        </div>
      ) : (
        <>
          <div className="admin__user">
            <ButtonBack />

            <div className="admin__user__name">ID: {mas.mas.id}</div>
            <div className="admin__user__name">Имя: {mas.mas.name}</div>
          </div>
          <div className="admin__user">
            <div className="admin__user__name">Фамилия: {mas.mas.surname}</div>
          </div>

          <div className="admin__user">
            <form>
              {mas.mas.active ? (
                <button
                  className="admin__results__link"
                  onClick={disableHandler}
                  style={{ cursor: "pointer", backgroundColor: "crimson" }}
                >
                  Отключить
                </button>
              ) : (
                <button
                  className="admin__results__link"
                  onClick={enableHandler}
                  style={{ cursor: "pointer", backgroundColor: "#008b8b" }}
                >
                  Включить
                </button>
              )}
            </form>
          </div>

          <div className="admin__user__results">
            <div className="admin__user__title">Аптеки:</div>
            {mas.pharmacies.length === 0 ? (
              <>
                <br />
                <br />
                <p style={{ fontSize: 32, color: "crimson" }}>
                  Здесь пока пусто
                </p>

                {mas.mas.active === 1 && (
                  <div className="admin__user__items">
                    <div className="admin__user__item_mas">
                      <div>
                        <Link to={"/admin/mas/" + mas.mas.id + "/ph/add"}>
                          Добавить аптеку
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="admin__user__items">
                {mas.pharmacies.map((ph) => (
                  <div className="admin__user__item_mas" key={ph.id}>
                    <div>
                      <Link to={"/admin/pharmacies/" + ph.id}>
                        {ph.short_name}
                      </Link>
                    </div>
                    <div>
                      <button
                        type="submit"
                        onClick={() => deleteHandler(mas.mas.id, ph.id)}
                      >
                        Удалить
                      </button>
                    </div>
                  </div>
                ))}

                <div className="admin__user__item_mas">
                  <div>
                    <Link to={"/admin/mas/" + mas.mas.id + "/ph/add"}>
                      Добавить аптеку
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
      {success && <LittleNotify title={success} close={closeSuccess} />}
    </div>
  );
};

export default MasUserPage;
